module.exports = __webpack_public_path__ + "static/media/a6_parking.a2508bf6.png";